import Emitter from "es6-event-emitter";
import { generateCoverURL } from "./../utilities/utils";

export default class NewsstandRedirectingStore extends Emitter {
  packages = [];

  data = null;

  _apiManager = null;

  _imageSizes = null;

  _downloadToken = null;

  constructor(apiManager, data, imageSizes, downloadToken) {
    super();
    this._apiManager = apiManager;
    this.data = data;
    this._imageSizes = imageSizes;
    this._downloadToken = downloadToken;
  }

  getAllContentPackages() {
    return this.packages;
  }

  loadNewsstandRedirecting() {
    const promises = [];
    this.data.forEach((singleData) => {
      promises.push(this.loadSingleNewsstandRedirecting(singleData));
    });
    Promise.all(promises).then((data) => {
      this.packages = data;
      this.trigger("NewsstandRedirecting:loaded");
    });
  }

  loadSingleNewsstandRedirecting(singleData) {
    const promise = new Promise((resolve) => {
      this._apiManager
        .getContentPackageList(singleData.token, 1, singleData.url)
        .then((json) => {
          if (json && json[0]) {
            const result = this.normalizePub(json[0], singleData);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(() => {
          resolve(null);
        });
    });
    return promise;
  }

  normalizePub(pub, singleData) {
    const result = {};
    result.imageUrl = generateCoverURL(
      pub.ContentPackageId,
      this._imageSizes.S,
      pub.ThumbnailId,
      pub.Version,
      singleData.url
    );
    result.url = singleData.redirectingUrl;
    result.current = singleData.current;
    if (singleData.customLabel) {
      result.customLabel = singleData.customLabel;
    }

    if (singleData.class) {
      result.class = singleData.class;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/common/stores/newsstandRedirectingStore.js